import { Link } from "react-router-dom";
import { ArrowRight, Tv, Wifi, Clapperboard } from "lucide-react";
import { FadeUp } from "./Reveal";

export const ComboBanner = () => (
    <section
        data-testid="combo-banner"
        className="relative overflow-hidden bg-[#E61C24]"
    >
        <div className="bg-grid absolute inset-0 opacity-40" aria-hidden="true" />
        <div
            className="pointer-events-none absolute -left-24 top-1/2 h-96 w-96 -translate-y-1/2 rounded-full bg-white/15 blur-[110px]"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#00F0FF]/25 blur-[110px]"
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
            <FadeUp>
                <div className="flex flex-wrap items-center gap-3 font-mono text-xs font-bold tracking-[0.3em] text-white/85">
                    <span className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
                        <Wifi className="h-4 w-4" /> INTERNET
                    </span>
                    <span className="text-xl font-black text-white/60">+</span>
                    <span className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
                        <Tv className="h-4 w-4" /> TV
                    </span>
                    <span className="text-xl font-black text-white/60">+</span>
                    <span className="flex items-center gap-2 rounded-full bg-white/10 px-4 py-2">
                        <Clapperboard className="h-4 w-4" /> OTT
                    </span>
                </div>
            </FadeUp>

            <FadeUp delay={0.1}>
                <h2 className="font-display mt-8 max-w-3xl text-4xl font-black leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
                    One Connection. More Speed. More Entertainment.
                </h2>
            </FadeUp>

            <FadeUp delay={0.2}>
                <p className="mt-6 font-mono text-lg font-bold tracking-wide text-white sm:text-2xl">
                    6 MONTHS STARTING AT{" "}
                    <span className="text-3xl text-white sm:text-4xl">₹2,499/-*</span>
                </p>
                <p className="mt-3 max-w-xl text-xs leading-relaxed text-white/70">
                    *Indicative starting price for combo plans. Final pricing depends on
                    your selected speed, duration and router option. Contact customer
                    care for exact details.
                </p>
            </FadeUp>

            <FadeUp delay={0.3}>
                <Link
                    to="/get-connected"
                    data-testid="combo-cta-button"
                    className="group mt-9 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-base font-extrabold text-[#C7151C] shadow-[0_14px_40px_rgba(0,0,0,0.35)] transition-[transform,box-shadow] duration-200 hover:scale-105"
                >
                    Get Connected Today
                    <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
            </FadeUp>
        </div>
    </section>
);
